import './public_path';
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {configureAppStore} from '@nl/ui';
import {Router} from '@nl/core';
import {bindLinkTracking} from '@nl/neu';

import customReducers from './store/reducers';

import {convertConfig} from './utils';

import ConfigLoader from './ConfigLoader';
import App from './App';
import './styles/index.scss';

const root = document.getElementById('root');
if (root) {
	convertConfig().then((config) => {
		const store = configureAppStore({
			config: {
				data: config,
			},
			client: {
				data: {
					locale: config.DEFAULT_LANGUAGE,
				},
			},
		}, customReducers);
		render(
				(
						<Provider store={store}>
							<Router basename={window.CONTEXT_PATH || process.env.BASE_NAME}>
								<ConfigLoader>
									<App />
								</ConfigLoader>
							</Router>
						</Provider>
				),
				document.getElementById('root'),
				() => {
					bindLinkTracking();
				},
		);
	});
}
